import axios from "axios";
import { RESTAURANT_ID, BASE_URL } from "../redux/constants/Constants";

export const inaugration = async (token, data) => {
  const url = `${BASE_URL}/inaugration/`;

  // console.log(token, data);

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during inaugration:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const getInaugration = async (token) => {
  const url = `${BASE_URL}/inaugration/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during getInaugration:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const getRestaurantDetails = async () => {
  const url = `${BASE_URL}/restaurant-details/?type=user&restaurant_id=${RESTAURANT_ID}`;

  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during getRestaurantDetails:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const userRegistration = async (token, data) => {
  const url = `${BASE_URL}/user/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during registration:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const createCustomer = async (token, data, user_id) => {
  const url = `${BASE_URL}/customer/`;

  const userID = user_id ? user_id.toString() : "";

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during createCustomer:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const userLogin = async (token, data) => {
  const url = `${BASE_URL}/rest-auth/login/v1/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during login:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const userForgotPassword = async (token, data) => {
  const url = `${BASE_URL}/rest-auth/password/reset/v1/`;

  // console.log(token, data);

  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(token && token !== "undefined" ? { Authorization: `token ${token}` } : {}),
     },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      // Handle unauthorized access, for example, redirect to login page
      // console.log("Unauthorized access. Redirecting to login page.", error.response);
      return error.response;
    } else {
      // Handle other types of errors
      console.error("Error during login:", error);
      return error;
    }
  }
};



export const checkMobileNumberExists = async (token, mobileNumber) => {
  if (!mobileNumber) return false;
  const cleanMobile = String(mobileNumber).replace(/\s+/g, "").trim();
  const url = `${BASE_URL}/customer/?phone=${encodeURIComponent(cleanMobile)}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(token && token !== "undefined" ? { Authorization: `token ${token}` } : {}),
    },
  };
  try {
    const response = await axios.get(url, config);
    if (response?.data?.results?.length > 0) {
      return response.data.results;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const getProfileDetails = async (token, customerId) => {
  const url = `${BASE_URL}/customer/?customer_id=${customerId}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during profile details fetch:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
}

export const updateProfileDetails = async (token, customerId, data) => {
  const url = `${BASE_URL}/user/${customerId}/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.put(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during profile update:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
}

export const updateCustomerDetails = async (token, customerId, data) => {
  const url = `${BASE_URL}/customer/${customerId}/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.patch(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during customer update:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
}

export const changePasswordAPI = async (token, data) => {
  const url = `${BASE_URL}/rest-auth/password/reset/confirm/v1/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during password change:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
}

export const getUserShippingAddress = async (token, customer_id) => {
  const url = `${BASE_URL}/shipping/?customer_id=${customer_id}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const addUserShippingAddress = async (token, data) => {
  const url = `${BASE_URL}/shipping/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const updateUserShippingAddress = async (token, shippingID, data) => {
  const url = `${BASE_URL}/shipping/${shippingID}/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.put(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const getUserBllingAddress = async (token, customer_id) => {
  const url = `${BASE_URL}/billing/?customer_id=${customer_id}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const addUserBillingAddress = async (token, data) => {
  const url = `${BASE_URL}/billing/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const updateUserBillingAddress = async (token, billingID, data) => {
  const url = `${BASE_URL}/billing/${billingID}/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
     },
  };
  try {
    const response = await axios.put(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};


export const deleteUserShippingAddress = async (token, shippingID) => {
  const url = `${BASE_URL}/shipping/${shippingID}/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
    },
  };
  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const userGuestLogin = async (token, data) => {
  const url = `${BASE_URL}/send/code/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(token && token !== "undefined" ? { Authorization: `token ${token}` } : {}),
     },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during guest login:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

export const guestOtpVerification = async (token, data) => {
  const url = `${BASE_URL}/guest/verify/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(token && token !== "undefined" ? { Authorization: `token ${token}` } : {}),
     },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error("Error during guest OTP verification:", error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
};

